import { render, staticRenderFns } from "./SatelliteReports.vue?vue&type=template&id=45bb282c&scoped=true"
import script from "./SatelliteReports.vue?vue&type=script&lang=js"
export * from "./SatelliteReports.vue?vue&type=script&lang=js"
import style0 from "./SatelliteReports.vue?vue&type=style&index=0&id=45bb282c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb282c",
  null
  
)

export default component.exports